import {
  Box,
  Button,
  Flex,
  Heading,
  Input,
  Text,
  Textarea,
  useToast,
  VStack,
} from "@chakra-ui/react";
import React, { useRef } from "react";
import { BsGithub } from "react-icons/bs";
import { AiFillLinkedin } from "react-icons/ai";
import { SiGmail } from "react-icons/si";
import { BsFillTelephoneFill } from "react-icons/bs";
import {MdEmail} from "react-icons/md"
import { Link } from "react-scroll";
import emailjs from '@emailjs/browser';

const Contact = () => {

  const one = useRef()
  const two = useRef()
  const three = useRef()
  const four = useRef()
  

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_z0t2vdf', 'template_zpy4v8y', form.current, 'uBWh0866fF0kS3WnF')
      .then((result) => {
          console.log(result.text);
          alert("Message Send")
          e.target.reset()
      }, (error) => {
          console.log(error.text);
      });
  };

  const toast = useToast()


 const sendMessage = () => {
 console.log(one.current.value)

  toast({
    title: 'Message send',
   
    status: 'success',
    duration: 9000,
    isClosable: true,
  })
 }

  return (
    <Box id="contacts" pos={"relative"} zIndex={2} mb="45px" p="90px 0px">
      <Box display={"inline-block"}>
        <Heading color="black">Contact Me</Heading>
        <Box
          h="6px"
          w="100%"
          mt="10px"
          bg="rgb(34,83,200)"
          borderRadius={"5px"}
        ></Box>
      </Box>

      <Box display="flex" flexDir={["column","column","row"]} gap="50px" border="1px solid white" alignItems={"center"} w="65%" m="auto" mt="50px">

        <VStack  align="left" w={["100%","100%","70%"]}>
          <Text fontWeight={600} mb="10px" fontSize={"18px"} w="150px">
            Message Me
          </Text>
          <Flex gap="10px" w="100%">
            <Input  placeholder="name" />
            <Input placeholder="email" />
          </Flex>

          <Input ref={three} placeholder="subject" />
          <Textarea ref={four} maxH="100px" minH="100px" placeholder="message" />
          <Button
          onClick={sendMessage}
            bg="#2253c8"
            color="white"
           
            _hover={{
              border: "1px solid #2253c8",
              color: "#2253c8",
              bg: "white",

            }}
          >
            Send Message
          </Button>
        </VStack>



        <Box w={["100%","100%","400px"]} border="1px solid white">
            <Text  fontWeight={600} fontSize={"18px"} w="150px" mb="10px" >Get In Touch</Text>
        <Flex flexDir={"column"} gap="44px">

          <Flex alignItems={"center"} gap="15px" >
            <BsGithub color="#2253c8" size="25px" />
            <Link  target="_blank" href="https://github.com/utkarshqw" ><Text fontSize={"20px"} fontWeight={600}>utkarshqw</Text></Link>
          </Flex>


          <Flex alignItems={"center"} gap="15px" >
            <AiFillLinkedin color="#2253c8" size="25px" />
            <Link target="_blank" href="https://www.linkedin.com/in/utkarshqw/" ><Text fontSize={"20px"} fontWeight={600} >utkarshqw</Text></Link>
          </Flex>


          <Flex  alignItems={"center"} gap="15px" >
            <MdEmail color="#2253c8" style={{fontSize:"25px"}} />
            <Link href="#" ><Text fontSize={"20px"} fontWeight={600} >utkarshup75@gmail.com</Text></Link>
          </Flex>

          <Flex alignItems={"center"} gap="15px" >
            <BsFillTelephoneFill color="#2253c8" size="20px" />
            <Link href="#" ><Text fontSize={"20px"} fontWeight={600} >+91 83540 28499</Text></Link>
          </Flex>

          </Flex>
        </Box>
      </Box>
    </Box>
  );
};

export default Contact;
